import { render } from "./AuthHeader.vue?vue&type=template&id=d1091124"
const script = {}

import "./AuthHeader.vue?vue&type=style&index=0&id=d1091124&lang=scss"

import exportComponent from "/builds/anteup/anteup-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__